import {
  ALLIANZ_VARS,
  FEEDBACK_MESSAGES,
  PREFIX_PHONE_LIST,
  REGEX
} from '../../config'
// import { WEEK_MOMENTS, checkDay, checkHour } from '../deleteOutHoursDRP'
import { addErrorMsg } from './addErrorMsg'
import { generateLead } from './addLead'
import { THANKS_MODAL_LOADER } from './customThanksModal'
import { customValidationMsg } from './customValidationMsg'
import { deleteErrors } from './deleteErrors'
import { englishVersion } from './englishVersion'
import { DeuVersion } from './alemanVersion'
import { FranVersion } from './francesVersion'
import { SpanishVersion } from './spanishVersion'
import { SpanishVersionDos } from './spanishVersionDos'
import { setDuplicatedlabels } from './setDuplicatedlabels'
import {
  LANGUAGES,
  getLanguage,
  validationPhoneWithPrefix
} from './validationPhoneWithPrefix'

// Esta funcion llama a un ws que lo unico que hace devuelve 1 o 2 teniendo en cuenta lo que ha devuelto anteriormente. No se va a repetir 1,1,2,2 si no 1,2,1,2
const groupControlCheck = async () => {
  return new Promise((resolve, reject) => {
    DAL.Ajax({
      type: 'jsonp',
      url: 'https://apps.walmeric.com/clients/custom/ws/verti/groupControlCheck.php',
      data: {
        idTag: ALLIANZ_VARS.idTag,
        groupName: 'pruebasGrupoControlHogar',
        groupNumber: '2'
      }
    })
      .done(function (resp) {
        resolve(resp.number)
      })
      .fail(function (resp) {
        reject(resp.status)
      })
  })
}

export function modalIsClient2() {
  const observer = new MutationObserver(async () => {
    const $form = document.getElementById('custom-budget-form')

    if ($form !== null) {
      observer.disconnect()
      // Variables relacionadas con el formulario y su estructura
      const $form = document.getElementById('custom-budget-form')
      const $mainContainer = document.querySelector('.custom-budget')
      const $inputs = $form.querySelectorAll('input')
      const $buttonSubmitForm = $form.querySelector('button[type="submit"]')

      // Variables relacionadas con el tipo de cliente
      const $typeClientBtns = document.querySelectorAll(
        '.custom-budget__client-btn'
      )
      const $typeClientBtnsNo = document.querySelectorAll(
        '.custom-budget__client-btn'
      )[0]
      const $clientType = document.getElementById('client-type')
      const $typeClientWrap = document.querySelector('.custom-budget__buttons')

      // Variables relacionadas con la entrada de datos
      //  const $nationality = document.getElementById("nationality")

      const $PrefixField = document.getElementById('custom-budget-phone-code')
      const $DNIField = document.getElementById('DNI-field')
      const $DNIFieldWrap = document.querySelector(
        '.custom-budget__dni-input-wrap'
      )
      const $phoneInput = $form.querySelector('input[name="telefono"]')
      const $nombreInput = $form.querySelector('input[name="nombre"]')
      const $emailInput = $form.querySelector('input[name="email"]')
      const $seguroInteresSelect = document.querySelector(
        '#seguro-interes-select'
      )

      // Variables relacionadas con la privacidad y mensajes
      const $privacyPolicy = document.getElementById('privacy-policy')
      const $explainMsgPhone = document.querySelector('.custom-budget__msg')

      // Variables relacionadas con la llamada y la fecha
      const $containerRingpool = document.querySelector('.custom-budget__call')
      const $callDateSelectWrap = document.getElementById('call_date-wrap')
      const [$callDateSelect] = document.getElementsByName('call_date')
      const callDateSelect = document.getElementById('call_date-select')

      englishVersion()
      DeuVersion()
      FranVersion()

      /* 
        El test a/b se hace solamente para fuera de horario.
        Nos ayudar de new Date para obtener la hora exacta del dia y ver si esta fuera de horario
        Modal SpanishVersion() muenstra el select    /   Modal SpanishVersionDos() elimina el select         
        Las modales(html) estan construidas en D1C!
      */
      const today = new Date()
      let hourNow = today.getHours()
      let dayNow = today.getDay()
      dayNow = dayNow == 0 ? 'Domingo' : dayNow
      dayNow = dayNow == 6 ? 'Sabado' : dayNow
      // Llamamos a la func groupControlCheck que devuelve 1 o 2
      let changeValueNumber = await groupControlCheck()

      // Comprobamos si esta Domingo o Sabado(horario diferente)
      if (dayNow !== 'Domingo' && dayNow !== 'Sabado') {
        // Si no es domingo ni Sabado entramos al horario de L-V y comprobamos para saber que modal enseñar
        if ((hourNow >= 0 && hourNow < 9) || (hourNow >= 20 && hourNow <= 24)) {
          console.log('Fuera de horario (L-V) - ' + changeValueNumber)
          // Devolvemos una modal o otra(select presente/no presente) dependiendo de changeValueNumber
          changeValueNumber === 1 ? SpanishVersion() : SpanishVersion()
        } else {
          // Dentro de horario siempre se enseña la modal sin el select
          console.log('Dentro de horario (L-V)')
          SpanishVersionDos()
        }
      } else if (dayNow === 'Domingo') {
        // Si es Domingo vamos a monstrar siempre la modal con select
        console.log('Domingo')
        SpanishVersion()
      } else if (dayNow === 'Sabado') {
        // Si es Sabado controlamos el horario para monstrar una modal o otra
        if (
          (hourNow >= 0 && hourNow < 10) ||
          (hourNow >= 17 && hourNow <= 24)
        ) {
          console.log('Fuera de horario (Sabado) - ' + changeValueNumber)
          // Devolvemos una modal o otra(select presente/no presente) dependiendo de changeValueNumber
          changeValueNumber === 1 ? SpanishVersion() : SpanishVersion()
        } else {
          // Dentro de horario siempre se enseña la modal sin el select
          console.log('Dentro de horario Sabado')
          SpanishVersionDos()
        }
      }

      let puedeSubmit = {}

      // Detectar si estamos en la página `isQuoteTestPage`
      const isQuoteTestPage =
        window.location.href === 'https://www.allianz.es/t/quote-test.html' ||
        window.location.href.indexOf('https://calcularseguro.allianz.es/') >= 0

      const isDecesosTestPage =
        window.location.href ===
          'https://www.allianz.es/seguros/landing/otros/seguro-decesos.html' ||
        (!document.getElementById('privacy-policy') && !!document.getElementById('accept-marketing-new')) // si no tienen privacy-policy significa que es la anterior modal

      console.log('nueva Modal', isDecesosTestPage)

      const checkErrors = () => {
        const thereAreErrors = $form.querySelectorAll(
          '.custom-budget__error'
        ).length

        const erroresReturn = Object.values(puedeSubmit).every(
          (isValid) => isValid
        )
        const noErrors = thereAreErrors === 0

        // Solo habilitar el botón si no hay errores y los campos son válidos
        if (erroresReturn && noErrors) {
          $buttonSubmitForm.removeAttribute('disabled')
          $buttonSubmitForm.classList.remove('custom-budget__submit-disabled')
        } else {
          $buttonSubmitForm.setAttribute('disabled', 'true')
          $buttonSubmitForm.classList.add('custom-budget__submit-disabled')
        }
      }

      // Si estamos en `isQuoteTestPage`, solo validar los campos `telefono`, `nombre` y `email`
      if (isQuoteTestPage) {
        puedeSubmit = {
          telefono: true,
          nombre: true,
          email: true
        }
        $buttonSubmitForm.removeAttribute('disabled')
        $buttonSubmitForm.classList.remove('custom-budget__submit-disabled')
      } else if (isDecesosTestPage) {
        puedeSubmit = {
          telefono: false,
          nombre: false,
          email: true,
          soy_cliente: false,
          'no-client': false,
          dni: false,
          'seguro-interes-select': false
        }
        $buttonSubmitForm.removeAttribute('disabled')
        $buttonSubmitForm.classList.remove('custom-budget__submit-disabled')
        //$buttonSubmitForm.setAttribute('disabled', 'true')
        //$buttonSubmitForm.classList.add('custom-budget__submit-disabled')
      } else {
        // Para otras páginas, mantener todos los campos que necesitan validación
        puedeSubmit = {
          telefono: false,
          nombre: false,
          // 'nacionality': false,
          soy_cliente: false,
          'no-client': false,
          dni: false,
          policy: false,
          'seguro-interes-select': false
        }
        $buttonSubmitForm.setAttribute('disabled', 'true')
        $buttonSubmitForm.classList.add('custom-budget__submit-disabled')
      }

      if (isQuoteTestPage) {
        // Validación de teléfono
        $phoneInput.addEventListener('change', (event) => {
          const { value } = event.target

          if (!/^[0-9]{9}$/.test(value)) {
            addErrorMsg({
              field: 'telefono',
              msg: 'Teléfono inválido'
            })
            puedeSubmit.telefono = false
          } else {
            puedeSubmit.telefono = true
          }
          console.log('puedeSubmit.telefono:', puedeSubmit.telefono)
          checkErrors()
        })

        // Validación de nombre
        $nombreInput.addEventListener('change', (event) => {
          const { value } = event.target
          console.log('Valor capturado: ', value)

          if (value === '') {
            addErrorMsg({
              field: 'nombre',
              msg: 'El nombre es requerido'
            })
            puedeSubmit.nombre = false
          } else if (!REGEX.JUST_LETTERS_WITH_SPECIALS.test(value)) {
            addErrorMsg({
              field: 'nombre',
              msg: 'El nombre solo debe contener letras'
            })
            puedeSubmit.nombre = false
          } else {
            puedeSubmit.nombre = true
          }
          console.log('puedeSubmit.nombre:', puedeSubmit.nombre)
          checkErrors()
        })

        // Validación de email
        $emailInput.addEventListener('change', (event) => {
          const { value } = event.target

          if (value === '') {
            addErrorMsg({
              field: 'email',
              msg: 'El email es requerido'
            })
            puedeSubmit.email = false
          } else if (!REGEX.EMAIL.test(value)) {
            addErrorMsg({
              field: 'email',
              msg: 'Email no válido'
            })
            puedeSubmit.email = false
          } else {
            puedeSubmit.email = true
          }
          console.log('puedeSubmit.telefono:', puedeSubmit.email)
          checkErrors()
        })
      } else if (isDecesosTestPage) {
        if ($seguroInteresSelect) {
          $seguroInteresSelect.addEventListener('change', (event) => {
            const { value } = event.target

            if (value === '') {
              addErrorMsg({
                field: 'seguro-interes-select',
                msg: getErrorMsg('SELECT_REQUIRED')
              })
              puedeSubmit['seguro-interes-select'] = false
            } else {
              puedeSubmit['seguro-interes-select'] = true
            }

            console.log('seguro-interes-select selected value', value)
            checkErrors()
          })
        } else {
          puedeSubmit['seguro-interes-select'] = true
        }

        // Validación de teléfono
        $phoneInput.addEventListener('change', (event) => {
          const { value } = event.target

          if (!/^[0-9]{9}$/.test(value)) {
            addErrorMsg({
              field: 'telefono',
              msg: 'Teléfono inválido'
            })
            puedeSubmit.telefono = false
          } else {
            puedeSubmit.telefono = true
          }
          console.log('puedeSubmit.telefono:', puedeSubmit.telefono)
          checkErrors()
        })

        // Validación de nombre
        $nombreInput.addEventListener('change', (event) => {
          const { value } = event.target
          console.log('Valor capturado: ', value)

          if (value === '') {
            addErrorMsg({
              field: 'nombre',
              msg: 'El nombre es requerido'
            })
            puedeSubmit.nombre = false
          } else if (!REGEX.JUST_LETTERS_WITH_SPECIALS.test(value)) {
            addErrorMsg({
              field: 'nombre',
              msg: 'El nombre solo debe contener letras'
            })
            puedeSubmit.nombre = false
          } else {
            puedeSubmit.nombre = true
          }
          console.log('puedeSubmit.nombre:', puedeSubmit.nombre)
          checkErrors()
        })

        // Validación de email
        $emailInput.addEventListener('change', (event) => {
          const { value } = event.target

          if (value != '' && !REGEX.EMAIL.test(value)) {
            addErrorMsg({
              field: 'email',
              msg: 'Email no válido'
            })
            puedeSubmit.email = false
          } else {
            puedeSubmit.email = true
          }
          console.log('puedeSubmit.email:', puedeSubmit.email)
          checkErrors()
        })

        $DNIField.addEventListener('change', (event) => {
          const { value } = event.target
          if (
            value !== '' &&
            !REGEX.DNI.test(value) &&
            !REGEX.NIE.test(value)
          ) {
            addErrorMsg({
              field: 'DNI',
              msg: getErrorMsg('DNI_INVALID')
            })
            puedeSubmit.dni = false
          } else {
            puedeSubmit.dni = true
          }
          console.log('dniInput', value)
          checkErrors()
        })

        $typeClientBtns.forEach((btn, _i, btns) => {
          btn.addEventListener('click', (event) => {
            const { name } = event.target
            btns.forEach((option) => option.classList.remove('active'))
            btn.classList.add('active')

            getAndRemoveError($typeClientWrap)

            if (name === 'client') {
              $clientType.value = true
              $DNIField.style.display = 'block'
              // Ajustamos aquí para asegurarnos de que no_cliente se establezca correctamente
              puedeSubmit['no-client'] = true
              puedeSubmit.soy_cliente = true
              // Establecemos dni en true cuando soy cliente
              puedeSubmit.dni = true
            }

            if (name === 'no-client') {
              $clientType.value = false
              $DNIField.style.display = 'none'
              getAndRemoveError($DNIFieldWrap)
              // Ajustamos aquí para asegurarnos de que no_cliente se establezca correctamente
              puedeSubmit['no-client'] = true
              // También establecemos soy_cliente y dni en true cuando no soy cliente
              puedeSubmit.soy_cliente = true
              puedeSubmit.dni = true
            }

            checkErrors()
          })
        })
      } else {
        if ($seguroInteresSelect) {
          $seguroInteresSelect.addEventListener('change', (event) => {
            const { value } = event.target

            if (value === '') {
              addErrorMsg({
                field: 'seguro-interes-select',
                msg: getErrorMsg('SELECT_REQUIRED')
              })
              puedeSubmit['seguro-interes-select'] = false
            } else {
              puedeSubmit['seguro-interes-select'] = true
            }

            console.log('seguro-interes-select selected value', value)
            checkErrors()
          })
        } else {
          puedeSubmit['seguro-interes-select'] = true
        }

        $phoneInput.addEventListener('change', (event) => {
          const { value } = event.target

          // Validación: solo permitir 9 dígitos y no caracteres especiales
          if (!/^[0-9]{9}$/.test(value)) {
            console.log(
              'Número de teléfono inválido: solo se permiten 9 dígitos y sin caracteres especiales.'
            )

            const phoneField = document.querySelector(
              '.custom-budget__field--phone'
            )
            const ingles = document.querySelector('.custom-budget--en')
            const frances = document.querySelector('.custom-budget--fr')
            const aleman = document.querySelector('.custom-budget--de')

            // Mensajes de error según el idioma
            let errorMsg = ''
            if (ingles) {
              errorMsg = 'Invalid phone number'
            } else if (frances) {
              errorMsg =
                'Numéro de téléphone invalide. Veuillez entrer un numéro correct'
            } else if (aleman) {
              errorMsg =
                'Ungültige Telefonnummer. Bitte geben Sie eine korrekte Nummer ein'
            } else {
              errorMsg = 'Teléfono inválido' // Mensaje por defecto en español
            }

            addErrorMsg({
              field: 'telefono',
              msg: errorMsg
            })

            if (phoneField && !ingles && !frances && !aleman) {
              // Solo entra si phoneField existe y ingles NO existe
              phoneField.style.display = 'block'
              console.log('entro') // Esto se ejecutará solo si ingles NO existe
            }

            puedeSubmit.telefono = false
            return // Salir temprano si no es válido
          }

          // Verificar si $PrefixField existe y tiene valor antes de usarlo; si no, usar prefijo predeterminado '+34'
          const selectedPrefix =
            $PrefixField && $PrefixField.value ? $PrefixField.value : '34'
          const phoneValue = `${selectedPrefix}${value}`
          console.log(phoneValue)

          // Verificar si $PrefixField existe antes de usarlo
          if ($PrefixField && $PrefixField.value) {
            console.log($PrefixField.value)

            validationPhoneWithPrefix({
              explainMsgPhone: $explainMsgPhone,
              phoneValue: value,
              prefixSelected: selectedPrefix
            })
          } else {
            // Manejo alternativo si $PrefixField no existe o no tiene valor
            console.log('Prefix field not found or has no value')
            validationPhoneWithPrefix({
              explainMsgPhone: $explainMsgPhone,
              phoneValue: value,
              prefixSelected: '34' // Usar +34 por defecto si no hay prefijo seleccionado
            })
          }

          if (value === '') {
            $explainMsgPhone?.remove()
            addErrorMsg({
              field: 'telefono',
              msg: ingles
                ? 'Phone number is required'
                : frances
                ? 'Le numéro de téléphone est requis'
                : aleman
                ? 'Telefonnummer ist erforderlich'
                : getErrorMsg('PHONE_REQUIRED')
            })
            puedeSubmit.telefono = false
          } else {
            puedeSubmit.telefono = true
          }

          console.log('phoneInput', value)
          checkErrors()
        })

        $phoneInput.addEventListener('blur', setDuplicatedlabels)

        $nombreInput.addEventListener('change', (event) => {
          const { value } = event.target
          if (value === '') {
            addErrorMsg({
              field: 'nombre',
              msg: getErrorMsg('NAME_REQUIRED')
            })
            puedeSubmit.nombre = false
          } else if (!REGEX.JUST_LETTERS_WITH_SPECIALS.test(value)) {
            addErrorMsg({
              field: 'nombre',
              msg: getErrorMsg('NAME_INVALID')
            })
            puedeSubmit.nombre = false
          } else {
            puedeSubmit.nombre = true
          }
          console.log('nombreInput', value)
          checkErrors()
        })

        $emailInput.addEventListener('change', (event) => {
          const { value } = event.target
          puedeSubmit.email = true
          getAndRemoveError($emailInput)

          console.log('emailInput', value)
          checkErrors()
        })

        $DNIField.addEventListener('change', (event) => {
          const { value } = event.target
          if (
            value !== '' &&
            !REGEX.DNI.test(value) &&
            !REGEX.NIE.test(value)
          ) {
            addErrorMsg({
              field: 'DNI',
              msg: getErrorMsg('DNI_INVALID')
            })
            puedeSubmit.dni = false
          } else {
            puedeSubmit.dni = true
          }
          console.log('dniInput', value)
          checkErrors()
        })

        $typeClientBtns.forEach((btn, _i, btns) => {
          btn.addEventListener('click', (event) => {
            const { name } = event.target
            btns.forEach((option) => option.classList.remove('active'))
            btn.classList.add('active')

            getAndRemoveError($typeClientWrap)

            if (name === 'client') {
              $clientType.value = true
              $DNIField.style.display = 'block'
              // Ajustamos aquí para asegurarnos de que no_cliente se establezca correctamente
              puedeSubmit['no-client'] = true
              puedeSubmit.soy_cliente = true
              // Establecemos dni en true cuando soy cliente
              puedeSubmit.dni = true
            }

            if (name === 'no-client') {
              $clientType.value = false
              $DNIField.style.display = 'none'
              getAndRemoveError($DNIFieldWrap)
              // Ajustamos aquí para asegurarnos de que no_cliente se establezca correctamente
              puedeSubmit['no-client'] = true
              // También establecemos soy_cliente y dni en true cuando no soy cliente
              puedeSubmit.soy_cliente = true
              puedeSubmit.dni = true
            }

            checkErrors()
          })
        })

        $privacyPolicy.addEventListener('change', (event) => {
          const { checked } = event.target
          if (!checked) {
            addErrorMsg({
              field: 'politica',
              msg: getErrorMsg('PRIVACY_POLICY')
            })
            puedeSubmit.policy = false
          } else {
            puedeSubmit.policy = true
          }

          checkErrors()
        })

        // fin comprobaciones antes de submit
      }

      // Función para obtener mensajes de error según el idioma
      const getErrorMsg = (errorType) => {
        return getLanguage() === LANGUAGES.EN
          ? FEEDBACK_MESSAGES.ERROR[`${errorType}_EN`]
          : getLanguage() === LANGUAGES.DE
          ? FEEDBACK_MESSAGES.ERROR[`${errorType}_DE`]
          : getLanguage() === LANGUAGES.FR
          ? FEEDBACK_MESSAGES.ERROR[`${errorType}_FR`]
          : FEEDBACK_MESSAGES.ERROR[errorType]
      }

      // if (
      //   checkDay() === WEEK_MOMENTS.SATURDAY ||
      //   checkDay() === WEEK_MOMENTS.SUNDAY
      //   ||
      //   !checkHour({
      //     start: 9,
      //     end: 20,
      //     customMinutes: 0
      //   })
      // ) {
      //   if ($explainMsgPhone !== null) {
      //     $explainMsgPhone.innerText = FEEDBACK_MESSAGES.HOURS.OFFICE_OFF
      //   }
      //   $containerRingpool?.remove()
      // }
      const now = new Date()
      const currentDay = now.getDay()
      const currentHour = now.getHours()

      const WEEK_MOMENTS = {
        SUNDAY: 0,
        SATURDAY: 6
      }

      function shouldRemoveContainer() {
        return (
          (currentDay >= 1 &&
            currentDay <= 5 &&
            ((currentHour < 9 && currentHour >= 0) ||
              (currentHour >= 20 && currentHour <= 23))) ||
          (currentDay === WEEK_MOMENTS.SATURDAY &&
            ((currentHour < 10 && currentHour >= 0) ||
              (currentHour >= 18 && currentHour <= 23))) ||
          currentDay === WEEK_MOMENTS.SUNDAY
        )
      }

      if (shouldRemoveContainer()) {
        if ($explainMsgPhone !== null) {
          $explainMsgPhone.innerText = FEEDBACK_MESSAGES.HOURS.OFFICE_OFF
        }
        $containerRingpool?.remove()
      }

      const getAndRemoveError = (node) => {
        const nodeWithError = node.querySelector('.custom-budget__error')
        if (nodeWithError) nodeWithError.remove()
      }

      deleteErrors($inputs)

      $typeClientBtns.forEach((btn, _i, btns) => {
        btn.addEventListener('click', (event) => {
          const { name } = event.target
          btns.forEach((option) => option.classList.remove('active'))
          btn.classList.add('active')

          getAndRemoveError($typeClientWrap)

          if (name === 'client') {
            $clientType.value = true
            $DNIField.style.display = 'block'
          }

          if (name === 'no-client') {
            $clientType.value = false
            $DNIField.style.display = 'none'
            getAndRemoveError($DNIFieldWrap)
          }
        })
      })

      $form.addEventListener('submit', (event) => {
        event.preventDefault()

        customValidationMsg()

        const formData = new FormData(event.target)
        const data = Object.fromEntries(formData)
        const fields = Object.entries(data)

        const phoneNumberInput = document.querySelector(
          'input[name="telefono"]'
        )
        const $PrefixField = document.getElementById('custom-budget-phone-code')
        const selectedPrefix = $PrefixField ? $PrefixField.value : '34'
        const phoneNumber = phoneNumberInput ? phoneNumberInput.value : ''
        // const formattedPhoneNumber = phoneNumber.startsWith('34') ? phoneNumber : `34${phoneNumber}`;
        const formattedPhoneNumber = phoneNumber.startsWith(selectedPrefix)
          ? phoneNumber
          : `${selectedPrefix}${phoneNumber}`
        data.telefono = formattedPhoneNumber

        /*console.log(formattedPhoneNumber)
        console.log(data)
        console.log(phoneNumber)*/

        // prueba new form
        if (isDecesosTestPage) {
          const isAccepted = document.getElementById('accept-marketing-new')
            ? document.getElementById('accept-marketing-new').checked
            : false

          data.acceptPrivacyPolicy = true
          data.acceptDataConsentGroup = false

          if (isAccepted) {
            data.acceptPublicity = true
            data.acceptDataConsentType = true
          } else {
            data.acceptPublicity = false
            data.acceptDataConsentType = false
          }
        }

        fields.forEach(([field, value]) => {
          if (field === 'nombre' && value === '') {
            addErrorMsg({
              field,
              msg:
                getLanguage() === LANGUAGES.EN
                  ? FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED_EN
                  : getLanguage() === LANGUAGES.DE
                  ? FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED_DE
                  : getLanguage() === LANGUAGES.FR
                  ? FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED_FR
                  : FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED
            })
          }

          if (
            field === 'nombre' &&
            !REGEX.JUST_LETTERS_WITH_SPECIALS.test(value)
          ) {
            addErrorMsg({
              field,
              msg:
                getLanguage() === LANGUAGES.EN
                  ? FEEDBACK_MESSAGES.ERROR.NAME_INVALID_EN
                  : getLanguage() === LANGUAGES.DE
                  ? FEEDBACK_MESSAGES.ERROR.NAME_INVALID_DE
                  : getLanguage() === LANGUAGES.FR
                  ? FEEDBACK_MESSAGES.ERROR.NAME_INVALID_FR
                  : FEEDBACK_MESSAGES.ERROR.NAME_INVALID
            })
          }

          if (field === 'telefono' && value === '') {
            $explainMsgPhone?.remove()
            addErrorMsg({
              field,
              msg:
                getLanguage() === LANGUAGES.EN
                  ? FEEDBACK_MESSAGES.ERROR.PHONE_REQUIRED_EN
                  : getLanguage() === LANGUAGES.DE
                  ? FEEDBACK_MESSAGES.ERROR.PHONE_REQUIRED_DE
                  : getLanguage() === LANGUAGES.FR
                  ? FEEDBACK_MESSAGES.ERROR.PHONE_REQUIRED_FR
                  : FEEDBACK_MESSAGES.ERROR.PHONE_REQUIRED
            })
          }

          // if (field === 'email' && value !== '' && !REGEX.EMAIL.test(value)) {
          //   addErrorMsg({
          //     field,
          //     msg:
          //       getLanguage() === LANGUAGES.EN
          //         ? FEEDBACK_MESSAGES.ERROR.EMAIL_INVALID_EN
          //         : getLanguage() === LANGUAGES.DE
          //         ? FEEDBACK_MESSAGES.ERROR.EMAIL_INVALID_DE
          //         : FEEDBACK_MESSAGES.ERROR.EMAIL_INVALID
          //   })
          // }

          if (field === 'call_date' && value === '') {
            addErrorMsg({
              field,
              msg:
                getLanguage() === LANGUAGES.EN
                  ? FEEDBACK_MESSAGES.ERROR.SELECT_THE_SCHEDULE_EN
                  : getLanguage() === LANGUAGES.DE
                  ? FEEDBACK_MESSAGES.ERROR.SELECT_THE_SCHEDULE_DE
                  : getLanguage() === LANGUAGES.FR
                  ? FEEDBACK_MESSAGES.ERROR.SELECT_THE_SCHEDULE_FR
                  : FEEDBACK_MESSAGES.ERROR.SELECT_THE_SCHEDULE
            })
          }

          getLanguage() === LANGUAGES.EN
            ? FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED_EN
            : getLanguage() === LANGUAGES.DE
            ? FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED_DE
            : getLanguage() === LANGUAGES.FR
            ? FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED_FR
            : FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED

          if (field === 'soy_cliente' && value === '') {
            addErrorMsg({
              field,
              msg:
                getLanguage() === LANGUAGES.EN
                  ? FEEDBACK_MESSAGES.ERROR.SELECT_CLIENT_TYPE_EN
                  : getLanguage() === LANGUAGES.DE
                  ? FEEDBACK_MESSAGES.ERROR.SELECT_CLIENT_TYPE_DE
                  : getLanguage() === LANGUAGES.FR
                  ? FEEDBACK_MESSAGES.ERROR.SELECT_CLIENT_TYPE_FR
                  : FEEDBACK_MESSAGES.ERROR.SELECT_CLIENT_TYPE
            })
          }

          if (
            field === 'DNI' &&
            value !== '' &&
            !REGEX.DNI.test(value) &&
            !REGEX.NIE.test(value)
          ) {
            addErrorMsg({
              field,
              msg:
                getLanguage() === LANGUAGES.EN
                  ? FEEDBACK_MESSAGES.ERROR.DNI_INVALID_EN
                  : getLanguage() === LANGUAGES.DE
                  ? FEEDBACK_MESSAGES.ERROR.DNI_INVALID_DE
                  : getLanguage() === LANGUAGES.FR
                  ? FEEDBACK_MESSAGES.ERROR.DNI_INVALID_FR
                  : FEEDBACK_MESSAGES.ERROR.DNI_INVALID
            })
          }
        })

        if ($DNIField?.style?.display === 'block' && $DNIField?.value === '') {
          addErrorMsg({
            field: 'DNI',
            msg:
              getLanguage() === LANGUAGES.EN
                ? FEEDBACK_MESSAGES.ERROR.DNI_REQUIRED_EN
                : getLanguage() === LANGUAGES.DE
                ? FEEDBACK_MESSAGES.ERROR.DNI_REQUIRED_DE
                : getLanguage() === LANGUAGES.FR
                ? FEEDBACK_MESSAGES.ERROR.DNI_REQUIRED_FR
                : FEEDBACK_MESSAGES.ERROR.DNI_REQUIRED
          })
        }

        $callDateSelect?.addEventListener('change', () => {
          getAndRemoveError($callDateSelectWrap)
        })
        if (!isQuoteTestPage && !isDecesosTestPage) {
          const privacyPolicy = document.getElementById('privacy-policy')
          if (!privacyPolicy.checked) {
            addErrorMsg({
              field: 'politica',
              msg:
                getLanguage() === LANGUAGES.EN
                  ? FEEDBACK_MESSAGES.ERROR.PRIVACY_POLICY_EN
                  : getLanguage() === LANGUAGES.DE
                  ? FEEDBACK_MESSAGES.ERROR.PRIVACY_POLICY_DE
                  : getLanguage() === LANGUAGES.FR
                  ? FEEDBACK_MESSAGES.ERROR.PRIVACY_POLICY_FR
                  : FEEDBACK_MESSAGES.ERROR.PRIVACY_POLICY
            })
          }
        }

        const thereAreErrors = $form.querySelectorAll(
          '.custom-budget__error'
        ).length

        if (thereAreErrors !== 0) return

        generateLead(event, { data, selectedPrefix })

        if (isDecesosTestPage) {
          // lanzamos evento (WCS-34429)
          window._satellite.track('submitFormModal')
          //console.log('_satellite.track("submitFormModal")')
        }

        $mainContainer.innerHTML = THANKS_MODAL_LOADER
      })
    }
  })

  observer.observe(document.body, { subtree: true, childList: true })
}
